import moment from 'moment';

export function isValidCellPhone(value) {
  if (!value) {
    return true;
  }
  const regex = /^(?:\+55\s?)?(?:\(?\d{2}\)?\s?)?(?:9\d{4}[-.\s]?\d{4})$/;
  if (!regex.test(value)) {
    return false;
  }

  const onlyNumbers = value.replace(/\D/g, '');
  if (/^(\d)\1+$/.test(onlyNumbers)) {
    return false;
  }

  return true;
}

export function isValidDate(value) {
  if (value.length !== 10) {
    return false;
  }

  const date = moment(value, 'DD/MM/YYYY');
  return date.isValid();
}

export function isDifferenceDays(date1Str, date2Str, difference) {
  if (!date1Str || !date2Str) {
    return true;
  }
  const date1 = moment(date1Str, 'DD/MM/YYYY');
  const date2 = moment(date2Str, 'DD/MM/YYYY');

  const diffDays = Math.abs(date1.diff(date2, 'days'));

  return diffDays <= difference;
}

export function isEndDateSameOrAfter(date1Str, date2Str) {
  if (!date1Str || !date2Str) {
    return true;
  }
  const starDate = moment(date1Str, 'DD/MM/YYYY');
  const endDate = moment(date2Str, 'DD/MM/YYYY');
  return endDate.isSameOrAfter(starDate);
}

export function isTodayLessOrSameThan(dateStr) {
  if (!dateStr) {
    return true;
  }
  const today = moment();
  const date = moment(dateStr, 'DD/MM/YYYY');

  return date.isSameOrBefore(today);
}

export function isMoreOrSameThanToday(dateStr) {
  if (!dateStr) {
    return true;
  }

  const today = moment().startOf('day');
  const date = moment(dateStr, 'DD/MM/YYYY').startOf('day');

  return date.isSameOrAfter(today);
}
